import theme from '../themes/default'

export default {
  wrap: {
    position: 'absolute',
    right: '0',
    top: '12px',
    width: '100px',
    '& .am-stepper-input': {
      'pointer-events': 'none',
    },
    '& .am-stepper-handler-up, .am-stepper-handler-down': {
      borderRadius: '50%',
      border: '2px solid #4A8CA1',
      '& .am-icon': {
        color: '#4A8CA1',
      },
    },
    '& .am-stepper-handler': {
      width: '25px',
      height: '25px',
      'line-height': '25px',
    },
    '& .am-stepper-input-wrap': {
      '& .am-stepper-input': {
        'margin-bottom': '6px',
      },
    },
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/OptionStepper.js